import React from "react";
import { useNavigate } from "react-router-dom";
import SignUpUserHeader from "../../components/header/SignUpUserHeader";
import "./UserOnboardingPage.css";
import { Col, Row } from "antd";

const Welcome = ({ onboardingData }) => {
  const navigate = useNavigate();
  const handleNext = (event) => {
    event.preventDefault();
    navigate("/onboarding/terms-and-conditions");
  };
  return (
    <Row className="welcome-onboarding-row">
      <Col lg={24}>
        <SignUpUserHeader />
      </Col>
      <Row
        gutter={24}
        className="welcome-onboarding-row-card-container"
      >
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          className="welcome-onboarding-inner-content-col"
        >
          <div className="onboarding-step">
            <h1>Welcome</h1>
            <p>
              We're glad to have you here! Get started by answering a few quick
              questions we have about your interest and background. This will
              help us to get to know you better, and tailor your homescreen to
              you. Don't worry, we assure you that your information is safe and
              will not be shared elsewhere.
              <br />
              <strong>Click next to begin your journey.</strong>
            </p>
            <button type="submit" onClick={handleNext}>
              Next
            </button>
          </div>
        </Col>
      </Row>
    </Row>
  );
};

export default Welcome;